import { apiRequest } from "@/shared/api/client";
import type { ApiResponse } from "@/shared/api/types";
import type { MediaSearchItem } from "@/features/search/api";
import {
  createSubscribe,
  listSubscribes,
  type Subscribe,
} from "@/features/subscribe/api";
import { mediaIdOf } from "@/shared/lib/format";

export type MediaDetail = MediaSearchItem;

export function fetchMediaDetail(
  mediaId: string,
  typeName: string,
  opts?: { title?: string; year?: string },
) {
  const params = new URLSearchParams();
  params.set("type_name", typeName);
  if (opts?.title) params.set("title", opts.title);
  if (opts?.year) params.set("year", opts.year);
  return apiRequest<MediaDetail>(
    `/api/v1/media/${encodeURIComponent(mediaId)}?${params.toString()}`,
  );
}

export async function findSubscribeForMedia(
  media: MediaDetail,
): Promise<Subscribe | null> {
  const list = await listSubscribes();
  const mid = mediaIdOf(media);
  if (!mid) return null;
  return (
    list.find((s) => {
      const sid = mediaIdOf({
        tmdbid: s.tmdbid,
        doubanid: s.doubanid,
        bangumiid: s.bangumiid,
      });
      return sid === mid;
    }) ?? null
  );
}

/**
 * 查询是否在媒体库。
 * 注意：后端用 success=false 表示不存在，不能走 apiResponse。
 */
export async function checkInLibrary(media: MediaDetail): Promise<boolean> {
  const params = new URLSearchParams();
  if (media.title) params.set("title", media.title);
  if (media.year) params.set("year", media.year);
  if (media.type) params.set("mtype", media.type);
  if (media.tmdb_id) params.set("tmdbid", String(media.tmdb_id));
  if (media.season != null) params.set("season", String(media.season));
  const res = await apiRequest<ApiResponse<{ item?: { id?: string } }>>(
    `/api/v1/mediaserver/exists?${params.toString()}`,
  );
  return Boolean(res?.success);
}

export function subscribeMedia(media: MediaDetail) {
  return createSubscribe({
    name: media.title,
    year: media.year,
    type: media.type,
    tmdbid: media.tmdb_id,
    doubanid: media.douban_id,
    bangumiid: media.bangumi_id,
    season: media.season,
    poster: media.poster_path,
    vote: media.vote_average,
    description: media.overview,
  });
}
